module.exports = __webpack_public_path__ + "static/peanut-4c33a72fa52c7820172da88961f9f7d0.svg";